<template>
  <transition name="fade">
    <div style="position: fixed; width: 100%" v-if="this.getModal">
  <div class="behindModal"></div>
    <div class="modal" style="display: unset;" role="dialog">
      <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                        <div class="col-xs-3 modalIcon warningImage"></div>
                        <div class="col-xs-9">
                                <h5 class="modal-title warningTheme" id="exampleModalLabel">Uyarı</h5>
                        </div>
                </div>
                <div class="modal-body">
                    <div class="modalTextArea" style="max-height: 40vh; overflow-y: auto; overflow-x: hidden; word-break: break-word; -webkit-overflow-scrolling: touch;">
                      <p class="c0"><span class="c1">KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ ÜYE &nbsp;AÇIK RIZA METNİ</span></p><p class="c3 c6"><span class="c2 c5"></span></p><p class="c6"><span class="c2">“Üye </span><span class="c2">Kişisel Verilerinin Korunması ve İşlenmesi Aydınlatma Metni</span><span class="c1">”ni okudum ve bu kapsamda:</span></p><p class="c0 c3"><span class="c1"></span></p><p class="c0"><span class="c1">Cihaz bilgilerimin kampanya düzenleyen firmaların uygulamada yer alan kampanya ve fırsatlarının</span></p><p class="c0"><span class="c1">tanıtımı amacıyla, kimlik bilgilerimin, iletişim bilgilerimin, cihaz bilgilerimin, alışveriş işlem bilgilerimin, ödül bilgilerimin, lokasyon verimin, sinema şube bilgimin, pazarlama bilgilerimin katılmış olduğum kampanya ve almış olduğum ürünlere ilişkin beğeni ve şikayetlerimin tespiti için anket yapılması amacıyla,</span></p><p class="c0"><span class="c1">Kimlik bilgilerimin, iletişim bilgilerimin, alışveriş işlem bilgilerimin, ödül bilgilerimin, sinema şube bilgimin, pazarlama bilgilerimin, cihaz bilgilerimin ve lokasyon bilgimin, beğeni, kullanım alışkanlıklarıma ve tercihlerime göre 3. kişilere ait mal hizmetlerin tanıtım ve duyurularının yapılması amacıyla işlenmesini kabul ederim.</span></p><p class="c0 c3"><span class="c1"></span></p><p class="c3 c7"><span class="c1"></span></p>                    </div>
                </div>
                <div class="modal-footer">
                <button class="warningTheme unselectable" @click="this.closeModal">Kapat</button>
                </div>
            </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    data() {
        return{}
    },
    computed: {
      getModal() {
        if(this.$store.state.consentModal === true) {
          return true;
        } else {
          return false;
        }
      }
    },
    methods: {
      ...mapActions[
        'consentModal'
      ],
      ...mapGetters[
        'consentModal'
      ],
      closeModal() {
        this.$store.dispatch('consentModal', false);
      }
    }
}
</script>

<style>
/* modal */
.behindModal {
  position: fixed;
  background-color: rgba(0,0,0,0.7);
  width: 100%;
  height: 100%;
  z-index: 0;
  top: 0;
}

.modal {
  margin-left: 0px;
  margin-right: 0px;
}

.modal-dialog {
  padding: 10px!important;
  font-family: BryantProBold;
  z-index: 9999;
  top: 0px;
  width: 96vw !important;
}

.successImage {
  background: url('./../../assets/images/ModalAlert/success-green.png');
  background-size: contain;
  height: 50px;
  width: 50px;
  float: left;
}
.warningImage {
  background: url('./../../assets/images/ModalAlert/info-orange.png');
  background-size: contain;
  height: 50px;
  width: 50px;
  float: left;
}

.modal-title {
  font-family: BryantProBold;
  font-size: 25px;
  line-height: 50px;
  background: none !important;
  color: #FF5100;
}

.successTheme {
  color: #34cb67;
  background-color: #34cb67;
}

.warningTheme {
  background-color: #FF5100;
}

.modalTextArea {
  font-size: 15px;
}


button {
  border: 0;
  border-radius: 10px;
  width: 100%;
  height: 55px;
  outline: none !important;
  transition: .2s ease;
  font-family: BryantProBold;
  font-size: 17px;
  color: #fff;
}

button:focus:active {
  opacity: 0.5;
  outline: none !important;
  transition: .2s ease;
  color: #fff;
}

/* modal */

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
